'use strict';

module.exports = {
  priceGroupOverridePriorityStart: 1000,
  globalRulePriorityStart: 2000,
  pricingGroupPriorityStart: 3000,
  defaultRulePriorityStart: 4000,
};
